import { Attribute, Modifier } from '@rhtml/custom-attributes';
import { Inject } from '@rxdi/core';
import { Subject } from 'rxjs';
import { switchMap, takeUntil } from 'rxjs/operators';

import { TranslateService } from './translate.service';

@Modifier({
  selector: 'translate',
})
export class TranslateModifier extends Attribute {
  @Inject(TranslateService)
  private translate: TranslateService;

  private destroy$ = new Subject();

  private originalText: string;

  OnInit() {
    this.originalText = this.element.innerText;
    this.translate.currentLanguage
      .pipe(
        takeUntil(this.destroy$),
        switchMap(() => this.translate.get(this.originalText))
      )
      .subscribe((text) => (this.element.innerText = text));
  }

  OnDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
